// @ts-nocheck
import * as types from './actionTypes';

export function updateLastPageSuccess(newLastPage: any) {
  return { type: types.UPDATE_LAST_PAGE_SUCCESS, lastPage: newLastPage };
}

export function updateBigcommerceInfoSuccess(newBCInfo: any) {
  return { type: types.UPDATE_BIGCOMMERCE_INFO_SUCCESS, bcInfo: newBCInfo };
}

export function updateSalesforceInfoSuccess(newSFInfo: any) {
  return {
    type: types.UPDATE_SALESFORCE_INFO_SUCCESS,
    salesforceInfo: newSFInfo,
  };
}

export function updateLastPage(lastPage: any, callback: any) {
  return (dispatch: any) => {
    dispatch(updateLastPageSuccess(lastPage));
    if (callback) {
      callback();
    } else {
      // browserHistory.push('/checkout');
    }
  };
}

export function updateBigcommerceInfo(bcInfo: any, callback: any) {
  return (dispatch: any) => {
    dispatch(updateBigcommerceInfoSuccess(bcInfo));
    if (callback) {
      callback();
    } else {
      // browserHistory.push('/checkout');
    }
  };
}

export function updateSalesforceInfo(salesforceInfo: any, callback: any) {
  return (dispatch: any) => {
    dispatch(updateSalesforceInfoSuccess(salesforceInfo));
    if (callback) {
      callback();
    } else {
      // browserHistory.push('/checkout');
    }
  };
}
